import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { WORKFLOW_FILTERS_MESSAGES, WorkflowFiltersMessages } from "./workflow-filters.messages";
import {
  WORKFLOW_SAVE_DIALOG_MESSAGES,
  WorkflowSaveDialogMessages,
} from "./workflow-save-dialog.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";
import { WORKFLOW_TABLE_MESSAGES, WorkflowTableMessages } from "./workflow-table.messages";
import { WORKFLOW_REQUEST_MESSAGES, WorkflowRequestMessages } from "./workflow-request-messages";

export type WorkflowEditDialogMessages = SidebarMessages &
  ActionButtonMessages &
  PopoverMessages &
  WorkflowFiltersMessages &
  WorkflowSaveDialogMessages &
  TableColumnsMessages &
  WorkflowTableMessages &
  WorkflowRequestMessages & {
    // Titles
    pageTitle: string;
    workflowTitle: string;
    breadCrumbTitle: string;
    workflowTableTitle: string;
    updateWorkflowPageTitle: string;
    workflowCardTitle: string;
    activeButton: string;

    configurationCardTitle: string;
    expirationSectionTitle: string;
    conversationTimeoutLabel: string;
    conversationTimeoutHint: string;
    expirationStepNameLabel: string;

    reactivationSectionTitle: string;
    reactivationTimeoutLabel: string;
    reactivationTimeoutHint: string;
    reactivationMessageLabel: string;
    reactivationMaxMessagesLabel: string;
    reactivationMaxMessagesHint: string;
    reactivationIntervalLabel: string;
    reactivationIntervalHint: string;
    errorRequiredReactivationMessage: string;

    // Tab Titles
    tabWorkflowDataLabel: string;
    tabStepsDataLabel: string;
    tabWorkflowLabel: string;
    tabSettingsLabel: string;
    stepFormTabInputLabel: string;
    stepFormTabProcessingLabel: string;
    stepFormTabOutputLabel: string;
    stepNavigateConfirmTitle: string;
    stepNavigateConfirmMessage: string;
    contentPreviewEmpty: string;
    stepNavigateShortcutAriaLabel: string;

    // Labels and Placeholders
    nameLabel: string;
    displayNameLabel: string;
    namePlaceholder: string;
    descriptionLabel: string;
    descriptionPlaceholder: string;
    avatarTitle: string;
    avatarHint: string;
    avatarAddButton: string;
    avatarUpdateButton: string;
    avatarRemoveButton: string;
    avatarInvalidFormatError: string;
    avatarUpdateError: string;
    errorAvatarExclusiveUsage: string;
    typeLabel: string;
    workflowElementIdLabel: string;
    menuOptionLabel: string;
    menuOptionHint: string;
    stepTypeLabel: string;
    allowAttendantTransferLabel: string;
    startMessageLabel: string;
    stepNameLabel: string;
    stepNumberLabel: string;
    startMessageEngineLabel: string;
    workflowEngineIdLabel: string;
    gotoWorkflowStepNameLabel: string;
    exceptionSourceWorkflowStepNameLabel: string;
    promptAIInputIdLabel: string;
    promptAIExceptionIdLabel: string;
    chatTransferAllowedLabel: string;
    chatTransferAllowedHint: string;
    messageBodyLabel: string;
    endMessageEngineLabel: string;
    exceptionMessageLabel: string;
    engineParametersLabel: string;
    globalVariablesLabel: string;
    globalVariablesHint: string;
    engineParametersHint: string;
    productDisplayTypeLabel: string;
    ordersSectionTitle: string;
    orderReportLayoutLabel: string;
    orderReportLayoutOrderOption: string;
    orderReportLayoutReceiptOption: string;
    productsSectionTitle: string;
    productSearchAssertivenessLabel: string;
    productSearchAssertivenessShortHint: string;
    productSearchAssertivenessTooltip: string;
    errorInvalidProductSearchAssertiveness: string;
    productDisplayTypeListOption: string;
    productDisplayTypeCarouselOption: string;
    productDisplayPreviewTitle: string;
    productDisplayPreviewDisclaimer: string;
    productDisplayPreviewVirtualAssistant: string;
    productDisplayPreviewProductNamePrefix: string;
    productDisplayPreviewDetailsHeader: string;
    productDisplayPreviewImagePlaceholder: string;
    productDisplayPreviewProductButtonPrefix: string;

    workflowKeyWordsSectionTitle: string;
    workflowKeyWordsHint: string;
    workflowKeyWordsRuleLabel: string;
    workflowKeyWordsKeywordsLabel: string;
    workflowKeyWordsDestinationLabel: string;
    workflowKeyWordsAddRuleLabel: string;
    workflowKeyWordsRemoveRuleLabel: string;
    errorWorkflowKeyWordsTooLong: string;
    errorWorkflowKeyWordsIncompleteRule: string;

    // Options
    stepTypeSOption: string;
    yesOption: string;
    noOption: string;
    stepTypeDOption: string;
    noneOption: string;
    orderStatus: string;
    startFlow: string;
    shopping: string;

    // Success Messages
    workflowCreationSuccess: string;
    workflowUpdateSuccess: string;
    stepUpdateSuccess: string;
    workflowStepCreateSuccess: string;

    // Error Messages
    errorRequiredName: string;
    errorRequiredDescription: string;
    errorRequiredStepType: string;
    errorRequiredStepName: string;
    errorRequiredStartMessage: string;
    errorRequiredMessageBody: string;
    errorRequiredWorkflowElement: string;
    errorRequiredWorkflowEngine: string;
    errorRequiredType: string;
    errorRequiredConversationTimeout: string;
    errorRequiredExpirationStepName: string;
    noVariablesAvailable: string;
    noTypeAvailable: string;
    workflowUpdateError: string;
    workflowCreateError: string;
    stepUpdateError: string;
    stepCreateError: string;

    // Column Headers
    stepTypeColumn: string;
    startMessageColumn: string;
    bodyMessageColumn: string;
    optionsColumn: string;
    stageColumn: string;
    stepNameColumn: string;
    elementColumn: string;
    originStageColumn: string;
    workflowTypeColumn: string;
    engineColumn: string;
    exceptionStepColumn: string;
    destinationStepColumn: string;
    inUseColumn: string;
    chatTransferColumn: string;

    // Dialog Messages
    deleteWorkflowStepDialogTitle: string;
    deleteWorkflowStepSuccess: string;
    deleteWorkflowStepDialogContent: string;
    deleteWorkflowStepReferencedIntro: string;
    deleteWorkflowStepReferencedDetailGoto: string;
    deleteWorkflowStepReferencedDetailException: string;
    deleteWorkflowStepReferencedDetailBoth: string;
    deleteWorkflowStepReferencedDetailMenuOption: string;
    deleteWorkflowStepReferencedOutro: string;
    deleteWorkflowStepPointsToOthersIntroOnly: string;
    deleteWorkflowStepPointsToOthersIntroAlso: string;
    deleteWorkflowStepRefTypeGoto: string;
    deleteWorkflowStepRefTypeException: string;
    deleteWorkflowStepRefTypeMenuOption: string;
    deleteWorkflowStepReferencedFinalMessage: string;
    deleteWorkflowStepDialogClose: string;
    deleteStepInUseHint: string;
    deleteWorkflowStepDialogCancel: string;
    deleteWorkflowStepDialogConfirm: string;
    deleteWorkflowStepInUseError: string;
    stepNumberAlreadyExist: string;
    stepNameAlreadyExist: string;
    removeWorkflowStepPopover: string;
    noStepsMessage: string;

    // Button Labels
    insertWorkflowButton: string;
    finishBtn: string;
  };

export const WORKFLOW_EDIT_DIALOG_MESSAGES: WorkflowEditDialogMessages = {
  // Titles
  pageTitle: "Agente",
  workflowTitle: "Agentes",
  breadCrumbTitle: "Agentes",
  workflowTableTitle: "Listagem de agentes",
  updateWorkflowPageTitle: "Editar etapas do agente.",
  workflowCardTitle: "Agente",
  activeButton: "Novo agente",

  // Tab Titles
  tabWorkflowDataLabel: "Agente",
  tabStepsDataLabel: "Etapas",
  tabWorkflowLabel: "Agente",
  tabSettingsLabel: "Configurações",
  stepFormTabInputLabel: "Entrada",
  stepFormTabProcessingLabel: "Processamento",
  stepFormTabOutputLabel: "Saída",
  stepNavigateConfirmTitle: "Navegar para etapa",
  stepNavigateConfirmMessage: "Deseja ir para o Step de destino?",
  contentPreviewEmpty: "Selecione uma opção para visualizar o conteúdo.",
  stepNavigateShortcutAriaLabel: "Ir para o step de destino",

  configurationCardTitle: "Configuração",
  expirationSectionTitle: "Expiração de conversa",
  conversationTimeoutLabel: "Tempo (minutos)",
  conversationTimeoutHint: "Digite 0 para não expirar a conversa",
  expirationStepNameLabel: "Etapa de expiração",
  errorRequiredConversationTimeout:
    "Tempo de expiração é obrigatório quando a expiração está habilitada.",
  errorRequiredExpirationStepName:
    "Etapa de expiração é obrigatória quando a expiração está habilitada.",

  reactivationSectionTitle: "Reativação de conversa",
  reactivationTimeoutLabel: "Tempo de inatividade (minutos)",
  reactivationTimeoutHint: "Tempo após o qual a primeira mensagem será enviada. Use 0 para desabilitar.",
  reactivationMessageLabel: "Mensagem de reativação",
  reactivationMaxMessagesLabel: "Máximo de mensagens",
  reactivationMaxMessagesHint: "Número máximo de tentativas (padrão: 5)",
  reactivationIntervalLabel: "Intervalo entre reativações (minutos)",
  reactivationIntervalHint: "Tempo entre cada tentativa (padrão: 60)",
  errorRequiredReactivationMessage:
    "Mensagem de reativação é obrigatória quando a reativação está habilitada.",

  // Labels and Placeholders
  nameLabel: "Nome",
  displayNameLabel: "Nome de exibição",
  namePlaceholder: "Digite o nome do agente...",
  descriptionLabel: "Descrição",
  descriptionPlaceholder: "Descreva o agente...",
  avatarTitle: "Avatar do atendimento",
  avatarHint:
    "Enviado como figurinha (sticker) no WhatsApp pela variável #AVATAR#. Formato sugerido: 512x512 pixels, fundo transparente, PNG.",
  avatarAddButton: "Adicionar avatar",
  avatarUpdateButton: "Alterar",
  avatarRemoveButton: "Remover",
  avatarInvalidFormatError: "O avatar deve ser uma imagem PNG.",
  avatarUpdateError: "Erro ao atualizar o avatar do agente.",
  errorAvatarExclusiveUsage: "A variável #AVATAR# deve ser utilizada sem qualquer texto adicional.",
  typeLabel: "Tipo",
  workflowElementIdLabel: "ID do Elemento do agente",
  menuOptionLabel: "Opção de Menu",
  menuOptionHint:
    "JSON das opções do menu. Em transferências, AttendantUserID deve ser o ID da fila de atendimento (não mais o ID do usuário).",
  stepTypeLabel: "Tipo de Etapa",
  allowAttendantTransferLabel: "Permite transferência de atendente",
  stepNameLabel: "Nome da etapa",
  stepNumberLabel: "Número da etapa",
  startMessageLabel: "Mensagem de Início",
  startMessageEngineLabel: "Mensagem de Início da Função",
  workflowEngineIdLabel: "Função",
  gotoWorkflowStepNameLabel: "Próxima Etapa",
  exceptionSourceWorkflowStepNameLabel: "Etapa de Exceção",
  promptAIInputIdLabel: "Prompt AI (entrada)",
  promptAIExceptionIdLabel: "Prompt AI (exceção)",
  chatTransferAllowedLabel: "Permitir transferência no chat",
  chatTransferAllowedHint:
    "Quando ativo, a etapa aparece nas ações do atendimento no formato [Agente -> etapa].",
  messageBodyLabel: "Corpo da Mensagem",
  endMessageEngineLabel: "Mensagem de Fim da Função",
  exceptionMessageLabel: "Mensagem de Exceção",
  engineParametersLabel: "Parâmetros do Motor",
  globalVariablesLabel: "Variáveis Globais",
  globalVariablesHint:
    "Use nas mensagens no formato #Nome# (ex.: #FirstName#). São dados do contato, da empresa ou do agente, disponíveis em qualquer etapa.",
  engineParametersHint:
    "Use nas mensagens no formato #Nome# (ex.: #Coupon#). São valores retornados pela função selecionada nesta etapa.",
  productsSectionTitle: "Produtos",
  productSearchAssertivenessLabel: "% de assertividade na busca do produto",
  productSearchAssertivenessShortHint:
    "Quanto maior o valor, mais precisa fica a busca e menos produtos são exibidos.\nUse 0 para mostrar todos os resultados relacionados.",
  productSearchAssertivenessTooltip:
    "O que é assertividade na busca?\n\nDefine quão rigorosa será a busca quando o cliente digita o nome de um produto.\n\n• 0% (bem ampla) — Mostra praticamente tudo relacionado ao termo, mesmo que não seja muito parecido. Ideal para explorar opções. Desliga o filtro por relevância.\n• 1% a 25% (ampla) — Exibe muitos resultados com alguma relação ao que foi digitado. Boa para buscas genéricas.\n• 26% a 50% (moderada) — Resultados mais relevantes. Equilíbrio entre quantidade e precisão. Padrão: 50.\n• 51% a 75% (precisa) — Produtos bem similares ao que foi pesquisado.\n• 76% a 100% (muito precisa) — Apenas resultados quase idênticos ao termo informado.\n\nNúmero entre 0 e 100.",
  errorInvalidProductSearchAssertiveness: "Informe um valor entre 0 e 100.",
  productDisplayTypeLabel: "Exibição de produtos",
  ordersSectionTitle: "Pedidos",
  orderReportLayoutLabel: "Formato de impressão do pedido",
  orderReportLayoutOrderOption: "Folha A4",
  orderReportLayoutReceiptOption: "Recibo",
  productDisplayTypeListOption: "Lista",
  productDisplayTypeCarouselOption: "Carrossel",
  productDisplayPreviewTitle: "Pré-visualização no WhatsApp",
  productDisplayPreviewDisclaimer:
    "Ilustrativo: o aplicativo pode exibir pequenas diferenças de layout, fonte e espaçamento.",
  productDisplayPreviewVirtualAssistant: "Assistente Virtual:",
  productDisplayPreviewProductNamePrefix: "Nome do produto:",
  productDisplayPreviewDetailsHeader: "Detalhes e preço:",
  productDisplayPreviewImagePlaceholder: "foto do produto",
  productDisplayPreviewProductButtonPrefix: "Produto ",

  workflowKeyWordsSectionTitle: "Desvio por palavras-chave",
  workflowKeyWordsHint:
    "Configure palavras que, ao serem enviadas pelo cliente, redirecionam a conversa para a etapa escolhida.",
  workflowKeyWordsRuleLabel: "Regra",
  workflowKeyWordsKeywordsLabel: "Palavras-chave",
  workflowKeyWordsDestinationLabel: "Etapa de destino",
  workflowKeyWordsAddRuleLabel: "Adicionar regra",
  workflowKeyWordsRemoveRuleLabel: "Remover regra",
  errorWorkflowKeyWordsTooLong:
    "A configuração de palavras-chave excede o limite de 1024 caracteres. Remova regras ou palavras.",
  errorWorkflowKeyWordsIncompleteRule:
    "Preencha palavra-chave e etapa de destino em todas as regras adicionadas antes de salvar.",

  // Options
  stepTypeSOption: "Estático",
  yesOption: "Sim",
  noOption: "Não",
  stepTypeDOption: "Dinâmico",
  noneOption: "Nenhum",
  orderStatus: "Status do Pedido",
  startFlow: "Iniciar Fluxo",
  shopping: "Compras",

  // Success Messages
  workflowCreationSuccess: "Fluxo criado com sucesso.",
  workflowUpdateSuccess: "Fluxo atualizado com sucesso.",
  stepUpdateSuccess: "Etapa do fluxo atualizada com sucesso.",
  workflowStepCreateSuccess: "Etapa do fluxo criada com sucesso.",

  // Error Messages
  errorRequiredName: "Nome do fluxo é obrigatório.",
  errorRequiredDescription: "Descrição do fluxo é obrigatória.",
  errorRequiredStepType: "Tipo de etapa é obrigatório.",
  errorRequiredStepName: "Nome da etapa é obrigatório.",
  errorRequiredStartMessage: "Mensagem de início é obrigatória.",
  errorRequiredMessageBody: "Corpo da mensagem é obrigatório.",
  errorRequiredWorkflowElement: "Elemento do fluxo é obrigatório.",
  errorRequiredWorkflowEngine: "Motor de fluxo é obrigatório.",
  errorRequiredType: "Tipo é obrigatório.",
  noVariablesAvailable: "Nenhuma variável disponível.",
  noTypeAvailable: "Nenhum tipo disponível.",
  workflowUpdateError: "Erro ao atualizar o fluxo.",
  workflowCreateError: "Erro ao criar o fluxo.",
  stepUpdateError: "Erro ao atualizar a etapa do fluxo.",
  stepCreateError: "Erro ao criar a etapa do fluxo.",

  // Column Headers (grid etapas – alinhado ao backoffice)
  stepTypeColumn: "Tipo de Etapa",
  startMessageColumn: "Mensagem de Início",
  bodyMessageColumn: "Corpo da Mensagem",
  optionsColumn: "Opções",
  stageColumn: "Etapa",
  stepNameColumn: "Nome da Etapa",
  elementColumn: "Elemento",
  originStageColumn: "Etapa de Origem",
  workflowTypeColumn: "Tipo de Fluxo",
  engineColumn: "Função",
  exceptionStepColumn: "Etapa de exceção",
  destinationStepColumn: "Etapa de destino",
  inUseColumn: "Em Uso",
  chatTransferColumn: "Transferência no chat",

  // Dialog Messages
  deleteWorkflowStepDialogTitle: "Excluir Etapa do Fluxo",
  deleteWorkflowStepSuccess: "Etapa do fluxo excluída com sucesso.",
  deleteWorkflowStepDialogContent: "Tem certeza que deseja excluir esta etapa do fluxo?",
  deleteWorkflowStepReferencedIntro:
    "Esta etapa está em uso ou referenciada pelos seguintes step:",
  deleteWorkflowStepReferencedDetailGoto:
    "Este step aponta para a etapa que você está excluindo em Próxima etapa.",
  deleteWorkflowStepReferencedDetailException:
    "Este step aponta para a etapa que você está excluindo em Etapa de exceção.",
  deleteWorkflowStepReferencedDetailBoth:
    "Este step aponta para a etapa que você está excluindo em Próxima etapa e em Etapa de exceção.",
  deleteWorkflowStepReferencedDetailMenuOption:
    "Este step referencia a etapa que você está excluindo em Opção de menu.",
  deleteWorkflowStepReferencedOutro: "Deseja realmente excluí-la?",
  /** Quando é o único bloco: este step aponta para outros */
  deleteWorkflowStepPointsToOthersIntroOnly: "Este step aponta para outro(s) step(s).",
  /** Quando já mostrou "outros referenciam": este step também aponta */
  deleteWorkflowStepPointsToOthersIntroAlso: "Além disso, este step aponta para outro(s) step(s).",
  /** Rótulos curtos para a lista (como este step aponta / como outro aponta) */
  deleteWorkflowStepRefTypeGoto: "Próxima etapa",
  deleteWorkflowStepRefTypeException: "Etapa de exceção",
  deleteWorkflowStepRefTypeMenuOption: "Opção de menu",
  /** Frase final do popup em uso */
  deleteWorkflowStepReferencedFinalMessage:
    "Para poder excluí-lo, não deve apontar para nenhum outro: remova primeiro todas as referências indicadas acima em Próxima etapa, Etapa de exceção ou Opção de menu.",
  deleteWorkflowStepDialogCancel: "Cancelar",
  deleteWorkflowStepDialogConfirm: "Confirmar",
  deleteWorkflowStepDialogClose: "Fechar",
  deleteWorkflowStepInUseError: "Não é possível excluir uma etapa que está em uso.",
  /** Exibido no popover quando a etapa está em uso: botão Excluir fica indisponível e mostra esta dica */
  deleteStepInUseHint:
    "Para excluir, pare de referenciar esta etapa em outros steps (Próxima etapa ou Etapa de exceção).",
  stepNumberAlreadyExist: "Já existe uma etapa com este número.",
  stepNameAlreadyExist: "Já existe uma etapa com este nome neste fluxo.",
  removeWorkflowStepPopover: "Excluir",
  noStepsMessage: "Nenhuma etapa cadastrada.",

  // Button Labels
  insertWorkflowButton: "Inserir Etapa",
  finishBtn: "Finalizar",

  ...POPOVER_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...WORKFLOW_FILTERS_MESSAGES,
  ...WORKFLOW_SAVE_DIALOG_MESSAGES,
  ...TABLE_COLUMNS_MESSAGES,
  ...WORKFLOW_TABLE_MESSAGES,
  ...WORKFLOW_REQUEST_MESSAGES,
};
